<script setup lang="ts">
    import IconAlignCenter from '@/components/icons/IconAlignCenter.vue';
    import IconAlignLeft from '@/components/icons/IconAlignLeft.vue';
    import IconAlignRight from '@/components/icons/IconAlignRight.vue';
    import IconJustify from '@/components/icons/IconJustify.vue';
    import { ETextAlignement } from '@/typescript/enums/ETextAlignement';
    import BaseButton from '@/components/BaseButton.vue';
    import { computed } from 'vue';

    const align = defineModel<ETextAlignement>(ETextAlignement.LEFT);

    const icons = [
        { component: IconAlignLeft, value: ETextAlignement.LEFT, label: 'Left' },
        { component: IconAlignCenter, value: ETextAlignement.CENTER, label: 'Center' },
        { component: IconAlignRight, value: ETextAlignement.RIGHT, label: 'Right' },
        { component: IconJustify, value: ETextAlignement.JUSTIFY, label: 'Justify' },
    ];

    const selectedIcon = computed(() => {
        return icons.find((icon) => icon.value === align.value);
    });

    function toggleAlign() {
        switch (align.value) {
            case ETextAlignement.CENTER:
                align.value = ETextAlignement.RIGHT;
                break;
            case ETextAlignement.JUSTIFY:
                align.value = ETextAlignement.LEFT;
                break;
            case ETextAlignement.LEFT:
                align.value = ETextAlignement.CENTER;
                break;
            case ETextAlignement.RIGHT:
                align.value = ETextAlignement.JUSTIFY;
                break;
            default:
                break;
        }
    }
</script>

<template>
    <BaseButton
        :has-border="false"
        class="mr-4 border-none"
        @click="toggleAlign"
    >
        <div class="flex h-12 w-12 items-center justify-center">
            <component :is="selectedIcon?.component" />
            <span class="sr-only text-xs">{{ selectedIcon?.label }}</span>
        </div>
    </BaseButton>
</template>
